/**
 * Not Found - fallback for unknown routes.
 *
 * Rendered inside Layout (via the App-level `path="*"` route) so a mistyped
 * or stale URL still gets the sidebar, nav, and a way back instead of a
 * blank <main> with nothing on it.
 */

import { Link } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function NotFound(): JSX.Element {
  useDocumentTitle('Page not found - Tacit');

  return (
    <Layout>
      <div className="mx-auto flex w-full max-w-2xl flex-1 flex-col items-center justify-center p-4 text-center sm:p-6 lg:p-8">
        <h1 className="text-3xl font-bold tracking-tight">Page not found</h1>
        <p className="mt-2 max-w-md text-muted-foreground">
          The page you are looking for does not exist or may have moved. Use one of the
          links below to get back on track.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/crm"
            className="interactive flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            <Compass className="h-5 w-5" aria-hidden="true" />
            Go to CRM
          </Link>
          <Link
            to="/"
            className="interactive flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-surface-hover"
          >
            <Home className="h-5 w-5" aria-hidden="true" />
            Go to Mission Control
          </Link>
        </div>
      </div>
    </Layout>
  );
}
